import * as actionTypes from "./actionTypes";
import { archivalManagementServices } from "../services/archivalManagement.service";
import { bankSettingsServices } from "../services/bankSettings.service";
import { alertsNotificationService } from "../services/alertNotification.service";
/******************* Archival Management **********************/
export const resetArchivalManagement = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_ARCHIVAL_MANAGEMENT,
  });
};

export const setProcessing = () => (dispatch) => {
  dispatch({
    type: actionTypes.SET_PROCESSING_ARCHIVAL_MANAGEMENT,
  });
};

export const getChannel = (error) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.LOAD_CHANNEL });

    const res = await archivalManagementServices.getChannel();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.GET_CHANNEL,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
      dispatch({ type: actionTypes.STOP_LOAD_CHANNEL });
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateChannel =
  (data, success, error) => async (dispatch, getState) => {
    try {
      const { archivalManagement } = getState();

      dispatch({ type: actionTypes.SET_PROCESSING_ARCHIVAL_MANAGEMENT });

      const res = await archivalManagementServices.updateChannel(
        archivalManagement.channel.uuid,
        data
      );

      if (
        res.data.responseCode === "SUCCESS" ||
        res.data.responseCode === "LICENSE_WARNING"
      ) {
        success(res.data.message);

        dispatch({
          type: actionTypes.UPDATE_CHANNEL,
          payload: res.data.returnObject,
        });
      } else if (res.data.responseCode === "VALIDATION_ERROR") {
        error(res.data.message);

        dispatch({ type: actionTypes.STOP_PROCESSING_ARCHIVAL_MANAGEMENT });
      }
    } catch (error) {
      console.log(error);
    }
  };

export const createChannel =
  (data, success, error) => async (dispatch, getState) => {
    try {
      // const channel = getState((state) => state.authentication.channelId);

      dispatch({ type: actionTypes.SET_PROCESSING_ARCHIVAL_MANAGEMENT });

      const res = await archivalManagementServices.createChannel(data);

      if (
        res.data.responseCode === "SUCCESS" ||
        res.data.responseCode === "LICENSE_WARNING"
      ) {
        success(res.data.message);

        dispatch({
          type: actionTypes.CREATE_CHANNEL,
          payload: res.data.returnObject,
        });
      } else if (res.data.responseCode === "VALIDATION_ERROR") {
        error(res.data.message);

        dispatch({ type: actionTypes.STOP_PROCESSING_ARCHIVAL_MANAGEMENT });
      }
    } catch (error) {
      console.log(error);
    }
  };

/******************* BANK SETTINGS **********************/
export const resetBankSettings = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_BANK_SETTINGS,
  });
};

export const setProcessingBankSettings = () => (dispatch) => {
  dispatch({
    type: actionTypes.SET_PROCESSING_BANK_SETTINGS,
  });
};

export const getCurrencies = (error) => async (dispatch) => {
  try {
    const res = await bankSettingsServices.getCurrencies();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.GET_CURRENCIES,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const getConfiguration = (error) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.LOAD_CONFIGURATION });

    const res = await bankSettingsServices.getConfiguration();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.GET_CONFIGURATION,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
      dispatch({ type: actionTypes.STOP_LOAD_CONFIGURATION });
    }
  } catch (error) {
    console.log(error);
  }
};

export const toggleUatMode = (error) => async (dispatch) => {
  try {
    const res = await bankSettingsServices.toggleUat();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.TOGGLE_UAT,
        payload: res.data.returnObject,
      });

      console.log(res.data.responseCode);
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateConfiguration =
  (data, success, error) => async (dispatch) => {
    try {
      dispatch({ type: actionTypes.SET_PROCESSING_BANK_SETTINGS });

      const res = await bankSettingsServices.updateConfiguration(data);

      if (
        res.data.responseCode === "SUCCESS" ||
        res.data.responseCode === "LICENSE_WARNING"
      ) {
        success(res.data.message);

        dispatch({
          type: actionTypes.UPDATE_CONFIGURATION,
          payload: res.data.returnObject,
        });
      } else if (res.data.responseCode === "VALIDATION_ERROR") {
        error(res.data.message);

        dispatch({ type: actionTypes.STOP_PROCESSING_BANK_SETTINGS });
      }
    } catch (e) {
      console.log(e);
      error("Failed");

      dispatch({ type: actionTypes.STOP_PROCESSING_BANK_SETTINGS });
    }
  };

export const createConfiguration =
  (data, success, error) => async (dispatch) => {
    try {
      dispatch({ type: actionTypes.SET_PROCESSING_BANK_SETTINGS });

      const res = await bankSettingsServices.createConfiguration(data);

      if (
        res.data.responseCode === "SUCCESS" ||
        res.data.responseCode === "LICENSE_WARNING"
      ) {
        success(res.data.message);

        dispatch({
          type: actionTypes.CREATE_CONFIGURATION,
          payload: res.data.returnObject,
        }).then(() => dispatch(getConfiguration(error)));
      } else if (res.data.responseCode === "VALIDATION_ERROR") {
        error(res.data.message);

        dispatch({ type: actionTypes.STOP_PROCESSING_BANK_SETTINGS });
      }
    } catch (error) {
      console.log(error);
    }
  };

export const sendTestEmail = (data, success, error) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SEND_TEST_EMAIL });

    const res = await bankSettingsServices.sendTestEmail(data);

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      success(res.data.message);
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
    }

    dispatch({ type: actionTypes.SET_SENDING_TEST_EMAIL, payload: false });
  } catch (error) {
    error(error.message);
    dispatch({ type: actionTypes.SET_SENDING_TEST_EMAIL, payload: false });
  }
};

/******************* ALERTS **********************/

export const resetAllAlerts = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_ALERTS,
  });
};

export const getAlerts =
  (current = true) =>
  async (dispatch) => {
    if (current) {
      dispatch({ type: actionTypes.LOAD_ALERTS });
    }

    try {
      const res = await alertsNotificationService.getAlerts();
      dispatch({
        type: actionTypes.GET_ALERT,
        payload: res.data.returnObject,
      });
    } catch (error) {
      console.log(error);
    }
  };

export const refreshAlerts = () => async (dispatch) => {
  try {
    const res = await alertsNotificationService.getAlerts();
    dispatch({
      type: actionTypes.GET_ALERT,
      payload: res.data.returnObject,
    });
  } catch (error) {
    console.log(error);
  }
};

export const updateDefault = (data, success, error) => async (dispatch) => {
  try {
    const res = await alertsNotificationService.updateDefault(data.id);
    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const CreateAlert = (data, success, error) => async (dispatch) => {
  try {
    const res = await alertsNotificationService.CreateAlert(data);

    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
      /* dispatch({
        type:actionTypes.CREATE_ALERT,
        payload:res.data.returnObject
      })  */
    } else {
      error(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateAlert =
  (data, success, error) => async (dispatch, getState) => {
    try {
      const res = await alertsNotificationService.updateAlert(data);

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);

        dispatch({
          type: actionTypes.UPDATE_ALERT,
          payload: res.data.returnObject,
        });
      } else {
        error(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

export const deleteAlert = (data, success, error) => async (dispatch) => {
  try {
    const res = await alertsNotificationService.deleteAlert(data.id);
    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);

      dispatch({
        type: actionTypes.DELETE_ALERT,
        payload: data.id,
      });
    } else {
      error(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const customerFileUpload = (data,success,error) => async (dispatch) => {
  
  try {
    const res = await alertsNotificationService.uploadCustomerFile(data)
if(res.data.responseCode === "SUCCESS" && res.data.returnObject.valid){
  success(res?.data?.message || "Uploaded Successflly")
  dispatch({
    type:actionTypes.CUSTOMER_FILE,
    payload:res?.data?.returnObject
  })


}
else {
  error(res?.data?.message)
}
  }
  catch(error){

    console.log(error)
  }
}

export const AddCustomerFile = (customerData,success,error,setOpenTable,setOpen) => async (dispatch) => {

  try {
  const res = await alertsNotificationService.InsertCustomerFile(customerData)
  if (res.data.responseCode === "SUCCESS") {
    
    success(res.data.message)
    setOpenTable(false)
    setOpen(false)
  } else {
    error(res.data.message);
    dispatch({
      type:actionTypes.FAILED_CUSTOMERS,
      payload:res?.data?.returnObject
    })
  }
  } catch (e) {
  console.log(error);
  error(e.message);
  }
  
  }

export const getGroups = (current = false,error) => async(dispatch) => {

  try {
    const res = await alertsNotificationService.GroupList();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type:actionTypes.ALL_GROUPS,
        payload:res?.data?.returnObject
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
}



